import Draggable from "react-draggable";
import "./cephalo.css";
import { useEffect, useState } from "react";
import { Button, ConfigProvider, Descriptions, message } from "antd";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate, useParams } from "react-router-dom";
import Url from "../../../apiCall/UrlConfig";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const AnalysesExam = (props) => {
  let navigate = useNavigate();
  const { id, idAnalyses } = useParams();
  const [pointPositions, setPointPositions] = useState({
    S: {
      x: 259,
      y: 389,
    },
    N: {
      x: 587,
      y: 256,
    },
    Me: {
      x: 622,
      y: 870,
    },
    Go: {
      x: 248,
      y: 773,
    },
    Gn: {
      x: 636,
      y: 842,
    },
    Or: {
      x: 547,
      y: 431,
    },
    Po: {
      x: 108,
      y: 462,
    },
    ANS: {
      x: 635,
      y: 541,
    },
    PNS: {
      x: 388,
      y: 561,
    },
    A: {
      x: 652,
      y: 612,
    },
    B: {
      x: 624,
      y: 720,
    },
    Ar: {
      x: 182,
      y: 543,
    },
    OP1: { x: 425, y: 658 },
    OP2: { x: 655, y: 670 },
  });

  const [lateralPhoto, setLateralPhoto] = useState(null);

  const [LateralCephaloAnaLysis, setCephaloAnalysis] = useState([]);

  useEffect(() => {
    console.log(pointPositions);
    _calculate();
  }, [pointPositions]);
  const _calculate = () => {
    console.log(pointPositions);
    const pointS = pointPositions["S"];
    const pointGo = pointPositions["Go"];
    const pointMe = pointPositions["Me"];
    const pointN = pointPositions["N"];
    const pointGn = pointPositions["Gn"];
    const pointA = pointPositions["A"];
    const pointB = pointPositions["B"];
    const pointAr = pointPositions["Ar"];
    //calculate jarobak index
    const distanceSGo = calculateDistance(pointS, pointGo);
    const distanceNMe = calculateDistance(pointN, pointMe);
    if (distanceSGo == 0 || distanceNMe == 0) {
      message.error("Please select all the points");
      return;
    }
    const jarobakIndex = (distanceSGo / distanceNMe) * 100;

    //calculate angle
    const YAxis = calculateAngle(pointN, pointS, pointGn);
    const ANBDegree = calculateSignedAngle(pointA, pointN, pointB);
    const ArticularAngle = calculateAngle(pointS, pointAr, pointGo);
    const SNAangle = calculateAngle(pointS, pointN, pointA);
    const SNBangle = calculateAngle(pointS, pointN, pointB);
    console.log("Jarobak Index:", jarobakIndex);
    console.log("YAxis:", YAxis);
    console.log("ANB", ANBDegree);
    console.log("Articular Angle", ArticularAngle);
    console.log("SNA", SNAangle);
    console.log("SNB", SNBangle);

    setCephaloAnalysis([
      {
        key: "jarobak Index",
        label: "jarobak Index",
        value: jarobakIndex.toFixed(2) + "  %  ",
      },
      {
        key: "YAxis",
        label: "YAxis",
        value: YAxis.toFixed(2),
      },
      {
        key: "ANB Degree",
        label: "ANB Degree",
        value: ANBDegree.toFixed(2),
      },
      {
        key: "ArticularAngle",
        label: "Articular Angle",
        value: ArticularAngle.toFixed(2),
      },
      {
        key: "SNA   angle",
        label: "SNAangle",
        value: SNAangle.toFixed(2),
      },
      {
        key: "SNB  angle",
        label: "SNB  angle",
        value: SNBangle.toFixed(2),
      },
    ]);
  };

  const calculateDistance = (point1, point2) => {
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const calculateAngle = (pointA, pointB, pointC) => {
    let dAB = calculateDistance(pointA, pointB);
    let dAC = calculateDistance(pointA, pointC);
    let dBC = calculateDistance(pointB, pointC);
    let acosTeta = (dAB ** 2 + dBC ** 2 - dAC ** 2) / (2 * dAB * dBC);
    let tettaRad = Math.acos(acosTeta);
    let tetaDegree = tettaRad * (180 / Math.PI);
    return tetaDegree;
  };
  const calculateSignedAngle = (pointA, pointB, pointC) => {
    const vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
    const vectorBC = { x: pointC.x - pointB.x, y: pointC.y - pointB.y };

    const dotProduct = vectorAB.x * vectorBC.x + vectorAB.y * vectorBC.y;
    const crossProduct = vectorAB.x * vectorBC.y - vectorAB.y * vectorBC.x;

    const magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
    const magnitudeBC = Math.sqrt(vectorBC.x ** 2 + vectorBC.y ** 2);

    let acosTeta = dotProduct / (magnitudeAB * magnitudeBC);

    // Ensure acosTeta is within the valid range [-1, 1]
    acosTeta = Math.max(-1, Math.min(1, acosTeta));

    let tettaRad = Math.acos(acosTeta);

    // Determine the sign of the angle based on the cross product
    if (crossProduct < 0) {
      tettaRad = -tettaRad;
    }

    // Convert angle to degrees
    let tetaDegree = tettaRad * (180 / Math.PI);

    if (tetaDegree < 0) {
      tetaDegree = 180 + tetaDegree;
    } else {
      tetaDegree = tetaDegree - 180;
    }

    return tetaDegree;
  };
  const _onstop = (event, data, label) => {
    setPointPositions((prevPositions) => ({
      ...prevPositions,
      [label]: { x: data.x, y: data.y },
    }));
  };

  const _returnDraggbleView = () => {
    let _output = [];
    for (let key in pointPositions) {
      _output.push(
        <Draggable
          onStop={(event, data) => _onstop(event, data, key)}
          bounds="parent"
          defaultPosition={pointPositions[key]}
          position={pointPositions[key]}
        >
          <div className="DragableContainer">
            <div className="circlePoint" />
            <div className="linewithAngle" />
            <div className="labelPoint">{key}</div>
          </div>
        </Draggable>
      );
    }
    return _output;
  };

  useEffect(() => {
    // alert(typeAnalyses);
    if (idAnalyses == undefined) {
      GetPatientLaterallPhoto();
    } else {
      GetPatientLaterallPhotoForEdit();
    }
    // GetPatientLaterallPhoto();
  }, []);

  const GetPatientLaterallPhoto = async () => {
    let url = Url.GetLateralPhotoExam;

    let res = await props.actions.CallCoreServicesActionWithToken(url, { id });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    if (res.data?.patientImages.length > 0) {
      let newPos = { ...pointPositions };
      let img = res.data?.patientImages[0];
      //for in newpos
      for (let key in newPos) {
        newPos[key].x = Math.floor(newPos[key].x * (img.imageWidth / 834));
        newPos[key].y = Math.floor(newPos[key].y * (img.imageHeight / 1000));
      }
      setPointPositions(newPos);

      if (res.data?.lateralCephaloAnalysesExam?.length > 0) {
        let analyses = res.data?.lateralCephaloAnalysesExam[0];
        let List_Position = analyses.lateralCephaloPositions;
        let _newPosistion = {};
        List_Position.map((Object) => {
          _newPosistion[Object.type] = {
            x: Object.xposition,
            y: Object.yposition,
          };
        });

        console.log("old position", pointPositions);
        console.log("new pos", _newPosistion);
        setPointPositions(_newPosistion);
      }

      console.log("new pos", newPos);
      setLateralPhoto(res.data?.patientImages[0]);
    }
  };

  const GetPatientLaterallPhotoForEdit = async () => {
    let url = Url.lateral_GetPhotoForEdit;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      IdPateint: id,
      IdAnalyses: idAnalyses,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    if (res.data?.patientImages.length > 0) {
      setLateralPhoto(res.data?.patientImages[0]);
    }

    if (res.data?.lateralCephaloAnalyses?.length > 0) {
      let analyses = res.data?.lateralCephaloAnalyses[0];
      let List_Position = analyses.lateralCephaloPositions;
      let _newPosistion = {};
      List_Position.map((Object) => {
        _newPosistion[Object.type] = {
          x: Object.xposition,
          y: Object.yposition,
        };
      });

      console.log("old position", pointPositions);
      console.log("new pos", _newPosistion);
      setPointPositions(_newPosistion);
    }
  };

  const _SaveAnalyses = async () => {
    let url = Url.saveLateralAnalysesExam;

    let lateralCephaloPositions = [];
    for (let key in pointPositions) {
      lateralCephaloPositions.push({
        type: key,
        xposition: pointPositions[key].x,
        yposition: pointPositions[key].y,
      });
    }

    let id = parseInt(idAnalyses);

    let data = {
      id: id ? id : 0,
      patientId: lateralPhoto.patientId,
      patientImageId: lateralPhoto.id,
      lateralCephaloPositions: lateralCephaloPositions,
    };

    let res = await props.actions.CallCoreServicesActionWithToken(url, data);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    message.success(res.message);
    navigate("/lateralchephalo/main");
  };

  return (
    <div dir="ltr">
      {lateralPhoto != null && (
        <>
          <div
            style={{
              backgroundColor: "red",
              position: "relative",
              width: lateralPhoto.imageWidth,
              height: lateralPhoto.imageHeight,
            }}
          >
            <img
              src={ImagePreAddress + lateralPhoto.imageUrl}
              className="imageCephalo"
              draggable={false}
            />
            {_returnDraggbleView()}
          </div>
          <ConfigProvider direction="ltr">
            <Descriptions bordered title="Lateral Cephalo Analyses">
              {LateralCephaloAnaLysis.map((item) => {
                return (
                  <Descriptions.Item key={item.key} label={item.label}>
                    {item.value}
                  </Descriptions.Item>
                );
              })}
            </Descriptions>
          </ConfigProvider>
          <Button
            loading={
              props.coreData[Url.saveLateralAnalyses]?.[Url.action]?.isFetching
            }
            type="primary"
            onClick={() => _SaveAnalyses()}
          >
            {idAnalyses == undefined ? "Save " : "Update "} Analyses
          </Button>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalysesExam);
